// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__13bsM","imageUploader":"EGiftCard_imageUploader__3mK_J"};